import { type FC } from 'react';

import { NotFoundPage } from '#packages/web/layouts/page/templates';
import { Message } from '#packages/web/foundations/feedback/message';

export const NotFoundPageRenderer: FC = () => (
  <NotFoundPage
    message={<Message>The page you are looking for does not exist.</Message>}
  />
);
